import { binarySearchByField } from 'utils';
//Коэффициент для перевода в радианы
const koef_rad = Math.PI / 180;
//Радиус земли
const earth_radius = 6372795;
export function calculateDistanceBetweenCoordinatesLastGPS(point_1, point_2) {
    if (!point_1 || !point_2)
        return 0;
    return calculateDistanceBetweenCoordinates([point_1.x, point_1.y], [point_2.x, point_2.y]);
}
//Считаем расстояние между двумя точками формулой гаверсинусов с модификацией для антиподов
export function calculateDistanceBetweenCoordinates(point_1, point_2) {
    if (!point_1 || !point_2)
        return 0;
    const point_1_lat = point_1[1];
    const point_2_lat = point_2[1];
    const point_1_lng = point_1[0];
    const point_2_lng = point_2[0];
    //Если вдруг прилетел null
    if (point_1_lat == null ||
        point_2_lat == null ||
        point_1_lng == null ||
        point_2_lng == null)
        return 0;
    //Если две точки равны
    if (point_1_lat === point_2_lat && point_1_lng === point_2_lng)
        return 0;
    //Переводим координаты в радианы
    //Широта - latitude - ось y
    const latitude_1 = point_1_lat * koef_rad;
    const latitude_2 = point_2_lat * koef_rad;
    //Долгота - longitude - ось x
    const longitude_1 = point_1_lng * koef_rad;
    const longitude_2 = point_2_lng * koef_rad;
    //косинусы и синусы широт и разных долгот
    const cos_lat_1 = Math.cos(latitude_1);
    const cos_lat_2 = Math.cos(latitude_2);
    const sin_lat_1 = Math.sin(latitude_1);
    const sin_lat_2 = Math.sin(latitude_2);
    const delta = longitude_2 - longitude_1;
    const cos_delta = Math.cos(delta);
    const sin_delta = Math.sin(delta);
    //вычисляем длину дуги большого круга
    const y = Math.sqrt(Math.pow(cos_lat_2 * sin_delta, 2) +
        Math.pow(cos_lat_1 * sin_lat_2 - sin_lat_1 * cos_lat_2 * cos_delta, 2));
    const x = sin_lat_1 * sin_lat_2 + cos_lat_1 * cos_lat_2 * cos_delta;
    const artan_dist = Math.atan2(y, x);
    return artan_dist * earth_radius;
}
//аналогична calculateDistanceBetweenCoordinates, только старая реализация.
//Возможно работает быстрее, разница 0.02%
export const distance = (a, b) => {
    const R = 6371000; // m
    const dLat = ((b[1] - a[1]) * Math.PI) / 180;
    const dLon = ((b[0] - a[0]) * Math.PI) / 180;
    const lat1 = (a[1] * Math.PI) / 180;
    const lat2 = (b[1] * Math.PI) / 180;
    const q = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    const c = 2 * Math.atan2(Math.sqrt(q), Math.sqrt(1 - q));
    return R * c;
};
//Пересчёт координат в цифры.
export const l2a = (coord) => [coord.lng || 0, coord.lat || 0];
//Сначала долгота, потом широта
export const a2l = (coord) => [coord[1], coord[0]];
export function loc_equal(a, b) {
    if (a === b) {
        return true;
    }
    if (a != null && b == null) {
        return false;
    }
    if (a == null && b != null) {
        return false;
    }
    return a[0] === b[0] && a[1] === b[1];
}
export function boundsToCenterAndZoom(bounds, [container_width, container_height]) {
    // (x_span ÷ 360) × (256 × 2^zoom) ≤ div_width
    // (y_span ÷ 180) × (256 × 2^zoom) ≤ div_height
    if (bounds == null) {
        return bounds;
    }
    if (container_width === 0 || container_height === 0) {
        return null;
    }
    const x_span = Math.abs(bounds[0][0] - bounds[1][0]);
    const y_span = Math.abs(bounds[0][1] - bounds[1][1]);
    const log2 = Math.log(2);
    return [
        [(bounds[0][0] + bounds[1][0]) / 2, (bounds[0][1] + bounds[1][1]) / 2],
        Math.floor(Math.min(Math.log((container_width * 360) / x_span / 256) / log2, Math.log((container_height * 180) / y_span / 256) / log2)),
    ];
}
//Расчитываем позицию окна карты для показа всего трека
export const calcGeoBounds = (gps, confirmed_viewport) => {
    const min_ms = confirmed_viewport[0];
    const max_ms = confirmed_viewport[1];
    const bin1 = binarySearchByField(gps, 'time', new Date(min_ms));
    const bin2 = binarySearchByField(gps, 'time', new Date(max_ms));
    if (bin1.r === gps.length) {
        return null;
    }
    let x_min = null, x_max = null, y_min = null, y_max = null;
    for (let i = bin1.l, end = bin2.l; i <= end; i++) {
        if (gps[i] == null)
            continue;
        const loc = gps[i].loc;
        if (x_min == null || loc[0] < x_min)
            x_min = loc[0];
        if (x_max == null || loc[0] > x_max)
            x_max = loc[0];
        if (y_min == null || loc[1] < y_min)
            y_min = loc[1];
        if (y_max == null || loc[1] > y_max)
            y_max = loc[1];
    }
    if (x_min == null)
        return null;
    if (x_max == null)
        return null;
    if (y_min == null)
        return null;
    if (y_max == null)
        return null;
    return [
        [x_min, y_min],
        [x_max, y_max],
    ];
};
export const boundsNonEmpty = (bounds) => bounds != null && bounds[0][0] !== bounds[1][0] && bounds[0][1] !== bounds[1][1];
export const expandBounds = (bounds, gap_fraction) => {
    if (bounds == null)
        return null;
    const w = Math.abs(bounds[0][0] - bounds[1][0]);
    const h = Math.abs(bounds[0][1] - bounds[1][1]);
    return [
        [
            Math.min(bounds[0][0], bounds[1][0]) - w * gap_fraction,
            Math.min(bounds[0][1], bounds[1][1]) - h * gap_fraction,
        ],
        [
            Math.max(bounds[0][0], bounds[1][0]) + w * gap_fraction,
            Math.max(bounds[0][1], bounds[1][1]) + h * gap_fraction,
        ],
    ];
};
